// Typed wrapper around /api/v1/admin/residents.

import type { PublicResident, UpdateResidentRequest } from '@residenone/shared';
import { api } from './api-client';
import { unitAddress } from './unit-address';

export type { PublicResident };

export async function listResidents(): Promise<PublicResident[]> {
  const { data } = await api.get<{ items: PublicResident[] }>('/admin/residents');
  return data.items;
}

export async function updateResident(
  id: string,
  body: UpdateResidentRequest,
): Promise<PublicResident> {
  const { data } = await api.patch<{ resident: PublicResident }>(
    `/admin/residents/${id}`,
    body,
  );
  return data.resident;
}

export async function deleteResident(id: string): Promise<void> {
  await api.delete(`/admin/residents/${id}`);
}

// Residents linked to one unit (units-page drawer).
export async function listUnitResidents(unitId: string): Promise<PublicResident[]> {
  const { data } = await api.get<{ items: PublicResident[] }>(
    `/admin/residents/by-unit/${unitId}`,
  );
  return data.items;
}

// Promote a resident to primary for their unit (demotes the current primary).
export async function setPrimaryResident(
  unitId: string,
  userId: string,
): Promise<PublicResident[]> {
  const { data } = await api.post<{ items: PublicResident[] }>('/admin/residents/primary', {
    unit_id: unitId,
    user_id: userId,
  });
  return data.items;
}

export function unitLabel(r: PublicResident): string {
  if (!r.unit_block || !r.unit_number) return 'Not linked';
  return unitAddress(r.unit_block, r.unit_number);
}
